module.exports = __webpack_public_path__ + "static/media/new_proj.37c41f0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/new_proj.jpg
// module id = 1842
// module chunks = 0